/*
 * @Description:
 * @Autor: Dai YueLin
 * @Date: 2022-04-27 13:39:07
 * @LastEditors: Dai YueLin
 * @LastEditTime: 2022-04-27 17:25:19
 */
const http = {
  namespaced: true,
  state: {
    requests: [],
  },
  mutations: {
    SET_REQUESTS: (state: any, request: any) => {
      state.requests.push(request);
    },
    CLEAR_REQUESTS: (state: any) => {
      state.requests.forEach((cancel: () => any) => {
        cancel && cancel();
      });
      state.requests = [];
    },
  },
  actions: {
    saveRequestQueue({ commit }: any, request: any) {
      return new Promise<void>((resolve) => {
        commit('SET_REQUESTS', request);
        resolve();
      });
    },
    clearRequests({ commit }: any) {
      commit('CLEAR_REQUESTS');
    },
  },
};

export default http;
